import api from './api';

export const userService = {
  getAllUsers: async (params) => {
    const response = await api.get('/users', { params });
    return response.data;
  },

  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  updateUser: async (id, data) => {
    const response = await api.put(`/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  approveUser: async (id) => {
    const response = await api.put(`/users/${id}/approve`);
    return response.data;
  },

  getUsersByDepartment: async (departmentId) => {
    const response = await api.get(`/users/department/${departmentId}`);
    return response.data;
  }
};
